import Session from 'session';
import Connection from 'connection';
import Org from 'org';
import Avatar from 'avatar';


export default Backbone.View.extend({
    initialize: function (options) {
        this.session = options.session;
        this.size = options.size || 120;
        this.progress = this.$('.avatarPreview__uploadProgress');
        this.listenTo(this.session, 'avatarUpload', this.renderUpload);
    },
    events: {
        'click': 'clickPreview',
        'buttonClick': 'clickPreview'
    },
    show: function () {
        this.$el.show();
        return this;
    },
    hide: function () {
        this.$el.hide();
        return this;
    },
    clickPreview: function (e) {
        if (this.model) {
            var props = {};
            if (this.model instanceof Session) {
                props.is_primary = true;
            } else if (this.model instanceof Org) {
                props.org = this.model.id;
            } else if (this.model instanceof Connection) {
                props.cid = this.model.id;
            } else {
                return;
            }
            this.model.session.trigger('avatarPrompt', this.model, {
                properties: props
            });
        }
    },
    setModel: function (model) {
        if (this.model) {
            this.stopListening(this.model);
        }
        this.model = model;
        this.setModelAvatar();
        this.listenTo(this.model, 'change:avatar', this.setModelAvatar);
        return this;
    },
    setModelAvatar: function () {
        if (this.model.get('avatar')) {
            this.setAvatar(new Avatar({
                id: this.model.get('avatar')
            }));
        } else {
            this.setAvatar(null);
        }
    },
    setAvatar: function (avatar) {
        this.avatar = avatar;
        this.render();
    },
    render: function () {
        if (this.avatar) {
            var url = this.avatar.getCachedSquareUrl(this.size);
            this.setImage(url);
        } else {
            this.clearImage();
        }
        return this;
    },
    setImage: function (url) {
        this.$el.css('background-image', 'url("' + url.replace(/"/g, '\\"') + '")');
        
        this.$el.removeClass('avatarPreview--new');
        this.$el.addClass('avatarPreview--change');
    },
    clearImage: function (url) {
        this.$el.css('background-image', 'none');
        
        this.$el.removeClass('avatarPreview--change');
        this.$el.addClass('avatarPreview--new');
    },
    renderUpload: function (avatar, dataUrl, uploadPromise, finalisePromise) {
        if (!avatar.matchesModel(this.model)) {
            return;
        }
        this.$el.addClass('avatarPreview--uploading');
        
        this.setImage(dataUrl);
        
        finalisePromise.done(_.bind(function () {
            this.setAvatar(avatar);
        }, this)).fail(_.bind(function (errorResponse) {
            this.model.trigger('postError', errorResponse);
            this.setAvatar(null);
        }, this)).always(_.bind(function () {
            this.$el.removeClass('avatarPreview--uploading');
        }, this));
        
        this.initProgress(uploadPromise, finalisePromise);
    },
    initProgress: function (uploadPromise, finalisePromise) {
        uploadPromise.progress(_.bind(function (evt, percentComplete) {
            this.progress.stop();
            if (evt) {
                var done = percentComplete == 100;
                this.progress.toggleClass('avatarPreview__uploadProgress--busy', done);
                this.progress.animate({
                    height: percentComplete + '%'
                });
            } else {
                this.progress.addClass('avatarPreview__uploadProgress--busy');
                this.progress.css('height', '100%');
            }
        }, this));
        finalisePromise.always(_.bind(function () {
            this.progress.removeClass('avatarPreview__uploadProgress--busy');
            this.progress.css('height', 0);
        }, this));
    },
});



// WEBPACK FOOTER //
// ./app/src/view/avataruploadpreview.es6